import React from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import Title from './baseComponents/Title';
import BaseButton from './baseButton';
import BaseInput from './baseInput';
import { UserActions } from '../redux/User';
import colors from '../utils/colors';

const Container = styled.div`
  z-index: 2;
  position: fixed;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  align-content: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
`;

const Modal = styled.div`
  align-self: center;
  position: relative;
  padding-bottom: 24px;
  width: 60%;
  max-width: 650px;
  border: 2px solid ${colors.grey[3]};
  border-radius: 8px;
  background-color: ${colors.grey[1]};
  align-content: center;
  justify-content: center;
  text-align: center;
  color: ${colors.primaryText};
`;

const SmallTitle = styled.h4`
  font-size: 16px;
  margin-top: 30px;
`;

const Space = styled.p`
  height: 50px;
`;

const Para = styled.p``;

const LoginMenu = () => {
  const dispatch = useDispatch();
  const {
    user: { loadSessionInput, sessionName, sessionToken },
    settings: { numberOfPlayers },
  } = useSelector((state) => state);

  return (
    <Container>
      <Modal>
        <Title text="Sessions" />
        {sessionName === '' ? (
          <React.Fragment key="withoutLogin">
            <SmallTitle>Load previous session</SmallTitle>
            <BaseInput
              key="LoadSessionInput"
              label="Session secret"
              value={loadSessionInput}
              onChange={(e) =>
                dispatch(UserActions.setLoadSessionInput(e.target.value))
              }
            />
            <BaseButton
              key="loadSessionButton"
              size="18"
              text="Load Session"
              onClick={() => dispatch(UserActions.loadSession())}
            />
          </React.Fragment>
        ) : (
          <React.Fragment key="LoggedIn">
            <SmallTitle>
              {numberOfPlayers > 1
                ? 'Share this session token with other players'
                : 'In session with secret:'}
            </SmallTitle>
            <Title text={sessionToken} />
            <Para>Keep it secret, keep it safe.</Para>
            <Para>You will need it to load this session in future.</Para>
          </React.Fragment>
        )}
        <Space />
        <BaseButton
          size="18"
          text="Close"
          onClick={() => dispatch(UserActions.setShowLoginModal(false))}
        />
      </Modal>
    </Container>
  );
};

export default LoginMenu;
